<template>
  <div>
    <div>
      <v-card class="pa-2">
        <v-layout class="ma-0" row wrap>
          <v-flex align-center sm7 xs12>
            <v-layout align-center>
              <v-flex shrink>
                <v-checkbox
                  :value="selected.includes(ticket)"
                  color="primary"
                  hide-details
                  style="margin: 0; padding: 0"
                  @change="onSelectTicket"
                ></v-checkbox>
              </v-flex>
              <v-flex style="font-weight: 800">
                #
                <CopyButtonVue :text="ticket.id"
                  >{{ ticket.id }}
                  <v-icon class="ml-1" small>file_copy</v-icon>
                </CopyButtonVue>

                |
                {{ ticket.subject }}
                <span v-if="ticket.cold_case">
                  <v-chip color="#2a9ba8" dark label small tile>COLD CASE</v-chip>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm5 xs12>
            <div class="text-xs-left text-sm-right">
              <v-layout
                :justify-end="$vuetify.breakpoint.smAndUp"
                :wrap="$vuetify.breakpoint.lgAndDown"
                align-center
              >
                <v-flex :style="{ minWidth: 0 }" class="pa-1">
                  <v-chip
                    v-if="ticket.channel == 'facebook'"
                    class="chipcustomfacebook social-chip ma-0"
                    color="#3b5998"
                    dark
                  >
                    <v-layout align-center>
                      <v-flex class="mr-2" shrink>
                        <em class="fab fa-facebook-square" />
                      </v-flex>
                      <v-flex :style="{ lineHeight: 'inherit !important' }" class="text-truncate"
                        >{{ ticket.customer_page_name }}
                      </v-flex>
                    </v-layout>
                  </v-chip>
                  <v-chip
                    v-else-if="ticket.channel == 'line'"
                    class="chipcustomline social-chip ma-0"
                    color="#00c300
                "
                    dark
                  >
                    <v-layout align-center>
                      <v-flex class="mr-2" shrink>
                        <em class="fab fa-line" />
                      </v-flex>
                      <v-flex :style="{ lineHeight: 'inherit !important' }" class="text-truncate"
                        >{{ ticket.customer_page_name }}
                      </v-flex>
                    </v-layout>
                  </v-chip>
                </v-flex>
                <v-flex shrink>
                  <v-btn
                    :loading="loadingHistory"
                    color="primary"
                    icon
                    outline
                    small
                    @click="handleShowHistory(ticket.id)"
                  >
                    <em class="fas fa-history" />
                  </v-btn>
                </v-flex>
                <v-flex shrink>
                  <v-btn
                    color="primary"
                    icon
                    outline
                    small
                    @click="goToLivechat(ticket, ticket.app)"
                  >
                    <em class="fas fa-comments" />
                  </v-btn>
                </v-flex>
                <v-flex shrink>
                  <v-btn color="primary" outline icon small @click.stop="editDialogOpen = true">
                    <v-icon small>edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-flex sm6 xs12>
            <v-layout wrap>
              <v-flex class="px-2 py-2" sm4 xs12>
                <v-avatar :size="$vuetify.breakpoint.name == 'xs' ? '40px' : '90px'">
                  <v-img :src="ticket.profile_pic"></v-img>
                </v-avatar>
              </v-flex>
              <v-flex class="px-2" sm8 xs12>
                <div style="font-size: small; color: #909090">
                  {{ ticket.first_name }} {{ ticket.last_name }}
                </div>

                <div style="font-size: 11px; color: grey">
                  <span>Date created: {{ ticket.starttime | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                  <div>End time: {{ ticket.endtime | DateFormat('DD/MM/YYYY HH:mm') }}</div>
                  <div>
                    Time closed:
                    <template v-if="ticket.starttime && ticket.endtime">
                      {{
                        addDurationUnit(
                          durationTime(
                            ticket.reasign_date ? ticket.reasign_date : ticket.starttime,
                            ticket.endtime
                          )
                        )
                      }}
                    </template>
                    <template v-else> -</template>
                  </div>
                  <div>
                    <span v-if="ticket.adminupdatetime" style="padding-right: 2px">
                      Agent responded: {{ dayLeft(ticket.adminupdatetime) }}
                    </span>
                    <span v-else>Pending for {{ dayLeft(ticket.starttime) }}</span>
                  </div>
                  <div :class="{ 'error--text': overdue }">
                    Due date: {{ ticket.duedate | DateFormat('DD/MM/YYYY HH:mm') }}
                    <v-tooltip v-if="overdue" bottom>
                      <template #activator="{ on }">
                        <v-icon color="error" small v-on="on">alarm</v-icon>
                      </template>
                      <span>Over due date</span>
                    </v-tooltip>
                  </div>
                  <div v-if="isAnanda">
                    <span
                      >User waiting time:
                      {{
                        durationTime(ticket.starttime, ticket.first_admin_first_response_time) ||
                        '-'
                      }}</span
                    >
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex class="px-2" sm6 xs12>
            <div
              style="
                word-break: break-word;
                height: 38.8px !important;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                color: grey;
                font-size: 13px;
              "
            >
              {{ ticket.details }}
            </div>
            <v-layout class="ma-0" row wrap>
              <v-flex xs12>
                <span class="groupticket2" @click="openshowDialogSelectAgent">
                  <span>
                    <em class="fas fa-users mr-2" />{{ getGroup ? getGroup.groupname : '-' }}
                    <span v-if="getSubGroup">
                      / {{ getSubGroup ? getSubGroup.subgroupname : '-' }}
                    </span>
                  </span>
                  <br />
                  <span
                    ><em class="fas fa-user-tie mr-2" />{{
                      getAgentName.display_name && getAgentName.adminid
                        ? getAgentName.display_name
                        : getAgentName
                        ? getAgentName.adminid
                        : '-'
                    }}</span
                  >
                </span>
              </v-flex>
              <v-flex xs12>
                <v-chip
                  v-for="(tag, k) in tags"
                  :key="k"
                  outline
                  style="
                    background-color: rgb(59, 89, 152);
                    border-color: rgb(59, 89, 152);
                    border-radius: 5px;
                    height: 24px;
                  "
                  >{{ tag }}
                </v-chip>
              </v-flex>
              <v-flex xs12>
                <template v-if="wrap_up_route && wrap_up_route.length > 0">
                  <template v-for="(item, index) in wrap_up_route">
                    <v-layout :key="index" class="mb-2 pa-1 z-border-red">
                      <v-flex>
                        <template v-for="(wrap_up_route, windex) in item">
                          <v-chip :key="`label_${windex}`" color="primary" label text-color="white"
                            >{{ wrap_up_route.title }}
                          </v-chip>
                          <em
                            v-if="windex + 1 < item.length"
                            :key="`chevron_${windex}`"
                            class="fas fa-chevron-right mx-1"
                          />
                        </template>
                      </v-flex>
                    </v-layout>
                  </template>
                </template>
              </v-flex>
              <v-flex v-if="isCIMBWealthPage" xs12>
                <span style="margin-right: 2px">⭐</span>
                <span class="primary--text">{{
                  (ticket.average_evaluation_point ? ticket.average_evaluation_point : 0)
                    | decimalFormat
                }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div>
          <div v-if="editloading" class="pt-2 text-xs-center">
            <v-progress-circular color="primary" indeterminate size="20"></v-progress-circular>
          </div>
          <div
            v-else
            class="my-2"
            style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center"
          >
            <div class="mr-2">
              <DropdownMenu
                :noicon="true"
                :options="priorityOptions"
                :value="ticket.priority"
                text-label="label"
                text-value="value"
                @change="updateTicket('priority', $event)"
              >
                <div
                  class="px-3 py-1 ma-1"
                  style="
                    text-transform: capitalized;
                    white-space: nowrap;
                    background-color: rgb(233 233 233);
                    border-radius: 6px;
                    border: 1px solid #b9b9b9;
                  "
                >
                  <i
                    :style="{ color: priorityColor(ticket.priority) }"
                    class="fas fa-circle mr-2"
                  />

                  <span style="text-transform: capitalized">
                    {{ ticket.priority || '-' | capitalize }}
                  </span>
                </div>
              </DropdownMenu>
            </div>
            <div>
              <DropdownMenu
                :noicon="true"
                :options="statusOptions"
                :value="ticket.status"
                text-label="label"
                text-value="value"
                @change="updateTicket('status', $event)"
              >
                <div
                  class="px-3 py-1 ma-1"
                  style="
                    white-space: nowrap;
                    background-color: rgb(233 233 233);
                    border-radius: 6px;
                    border: 1px solid #b9b9b9;
                    text-transform: capitalized;
                  "
                >
                  {{ handleGetStatus(ticket.status) || '-' | capitalize }}
                </div>
              </DropdownMenu>
            </div>
            <div>
              <DropdownMenu
                :noicon="true"
                :options="moodOptions"
                :value="ticket.mood"
                text-label="label"
                text-value="value"
                @change="updateTicket('mood', $event)"
              >
                <div
                  class="px-3 py-1 ma-1"
                  style="
                    white-space: nowrap;
                    background-color: rgb(233 233 233);
                    border-radius: 6px;
                    border: 1px solid #b9b9b9;
                    text-transform: capitalized;
                  "
                >
                  {{ handleGetMoodEmoji(ticket.mood) + ' ' }}{{ ticket.mood || '-' | capitalize }}
                </div>
              </DropdownMenu>
            </div>
          </div>
        </div>
      </v-card>
    </div>
    <v-dialog v-model="showDialogSelectAgent" persistent width="500px">
      <DialogSelectAgent
        v-if="showDialogSelectAgent"
        @close="showDialogSelectAgent = false"
        @selectedAgent="handleTransferTicket"
      />
    </v-dialog>

    <v-dialog v-if="historyData" v-model="showHistory" persistent width="800px">
      <HistoryStatus
        v-if="showHistory"
        v-model="historyData"
        @close="handleCloseHistory"
      ></HistoryStatus>
    </v-dialog>

    <v-dialog v-model="editDialogOpen" persistent :width="768">
      <v-card :style="{ display: 'flex', flexDirection: 'column', height: '90dvh !important' }">
        <TicketEditIframe
          v-if="editDialogOpen"
          :value="ticket"
          :style="{ flex: 1 }"
          @cancel="editDialogOpen = false"
          @submitted="onEditTicket"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import HistoryStatus from './HistoryStatus.vue'
import ticket3TicketManagementApi from '@/api/ticket3/ticket-management'
import DialogSelectAgent from './DialogSelectAgent.vue'
import { handleApiError } from '@/api/util'
import { moodOptions, priorityOptions } from '@/constants/ticket3/ticketConstant'
import ticketMixin from '@/mixins/ticketMixin'
import CopyButtonVue from '@/components/elements/CopyButton.vue'
import { PAGE, PAGE_GROUP } from '@/constants/page.js'
import TicketEditIframe from './TicketEditIframe.vue'

export default {
  components: {
    DropdownMenu,
    HistoryStatus,
    DialogSelectAgent,
    CopyButtonVue,
    TicketEditIframe
  },
  filters: {
    toCapitalized(value) {
      return value ? value.charAt(0).toUpperCase() + value.slice(1) : value
    }
  },
  mixins: [ticketMixin],
  props: {
    ticket: {
      type: Object,
      default: null
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      transferloading: false,
      transfer: {
        group: '',
        subgroup: '',
        assignedTo: ''
      },
      showDialogSelectAgent: false,
      showEdit: false,
      editloading: false,
      priority: 'Low',
      status: 'Pending',
      priorityOptions: priorityOptions,
      moodOptions: moodOptions,
      showHistory: false,
      historyData: null,
      loadingHistory: false,
      editDialogOpen: false
    }
  },
  computed: {
    wrap_up_route() {
      const wrap_up_route = this.handleTicketToWrapUpRoute(this.ticket)
      return wrap_up_route
    },
    loadingAgentData() {
      return this.loadingAgentGroup || this.loadingAgentSubGroup || this.loadingAgent
    },
    filterSubGroup() {
      if (this.transfer.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.transfer.group.id
        })
      } else {
        return []
      }
    },
    filterAgents() {
      if (this.transfer.group) {
        var agents = this.agent.filter((el) => {
          return el.admingroupid == this.transfer.group.id
        })
        if (this.transfer.subgroup) {
          agents = agents.filter((el) => {
            return el.adminsubgroupid == this.transfer.subgroup.id
          })
        }
        return agents
      } else {
        return this.agent ? this.agent : []
      }
    },
    ...mapGetters({
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      agent: 'getAgent',
      selectedBot: 'selectedBot',
      loadingAgentGroup: 'getLoadingAgentGroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      loadingAgent: 'getLoadingAgent',
      isCustomerSupportService: 'isCustomerSupportService',
      customerStatusOptions: 'customerStatusOptions'
    }),
    filteredAgentGroup() {
      if (this.agentGroup && this.agentGroup.length) {
        return this.agentGroup.filter((el) => ['Agent', 'Supervisor'].includes(el.groupname))
      } else {
        return []
      }
    },
    getGroup() {
      if (this.ticket.assigngroupid && this.agentGroup && this.agentGroup.length) {
        return this.agentGroup.find((el) => el.id == this.ticket.assigngroupid)
      } else return ''
    },
    getSubGroup() {
      if (this.ticket.assignsubgroupid && this.agentSubGroup && this.agentSubGroup.length) {
        return this.agentSubGroup.find((el) => el.id == this.ticket.assignsubgroupid)
      } else return ''
    },
    getAgentName() {
      if (
        (this.ticket.assignadminid || this.ticket.first_assign_admin_id) &&
        this.agent &&
        this.agent.length
      ) {
        const agent = this.agent.find(
          (el) => el.adminid == (this.ticket.assignadminid || this.ticket.first_assign_admin_id)
        )
        return agent
      } else return ''
    },
    tags() {
      if (this.ticket.tags) {
        return this.ticket.tags.split(',')
      } else return []
    },
    statusOptions() {
      if (this.isCustomerSupportService) {
        return this.customerStatusOptions.map((option) => {
          return {
            ...option,
            label: this.$t(`ticket_status.${option.value}`),
            disabled:
              ['answered'].includes(option.value) ||
              (['closed with survey'].includes(this.ticket.status) &&
                ['closed with survey'].includes(option.value))
          }
        })
      } else {
        const status = this.$store.getters.ticketStatusOptions
        if ([PAGE_GROUP.EMMA_CLINIC].includes(this.selectedBot.page_group)) {
          const statusFilter = status.filter((item) =>
            ['pending', 'answered', 'cancelled', 'cancelled by customer'].includes(item.value)
          )
          const index = 2
          const statusOption = [
            ...statusFilter.slice(0, index),
            { label: 'closed', value: 'closed without survey', color: '#e0e0e0' },
            ...statusFilter.slice(index)
          ]
          return statusOption.map((option) => {
            return { ...option, label: this.$t(`ticket_status.${option.value}`) }
          })
        } else {
          return status.map((option) => {
            return { ...option, label: this.$t(`ticket_status.${option.value}`) }
          })
        }
      }
    },
    isAnanda() {
      return PAGE.ANANDA.includes(this.selectedBot.pageid)
    },
    overdue() {
      if (!this.ticket.duedate) return false
      return moment(this.ticket.duedate).isBefore(moment())
    },
    isCIMBWealthPage() {
      return this.selectedBot.page_group === PAGE_GROUP.CIMB_WEALTH
    }
  },

  methods: {
    handleGetStatus(status) {
      const result = this.statusOptions.find((el) => el.value == status)
      return result ? result.label : null
    },
    onSelectTicket() {
      this.$emit('onSelect', this.ticket.id)
    },
    goToLivechat: function (user, app) {
      if (this.selectedBot.page_group === PAGE_GROUP.KKC) {
        this.$emit('chat', {
          search: user.userid,
          inbox: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app
        })
        return
      }

      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.userid,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app,
          pageid: this.ticket.pageid
        }
      })
      if (this.selectedBot.features.includes('all-in-one-chat-new')) {
        routeData = this.$router.resolve({
          name: 'allinonechat-new',
          path: '/' + this.currentLang + '/allinonechat-new',
          query: {
            search: user.userid,
            inbox: user.context == 'contactadmin' ? 'admin' : 'bot',
            app: app
          }
        })
      }
      window.open(routeData.href, '_blank')
    },
    async handleTransferTicket(transferInfo) {
      var isValid = await this.$validator.validate()

      if (isValid) {
        const data = {
          page_id: this.ticket.pageid,
          transfer_to_group_id: transferInfo.group ? transferInfo.group : null, // OPTIONAL
          transfer_to_sub_group_id: transferInfo.subgroup ? transferInfo.subgroup : null, // OPTIONAL
          transfer_to_admin_id: transferInfo.agent,
          ticket_id_list: [this.ticket.id]
        }

        this.transferloading = true
        try {
          const response = await ticket3TicketManagementApi.putTransferMultiTicket({ data: data })
          if (response.status == 200 || response.status == 204) {
            this.$emit('ontransfer')
          }
        } catch (error) {
          handleApiError(error)
        } finally {
          this.transferloading = false
          this.showDialogSelectAgent = false
        }
      }
    },
    openshowDialogSelectAgent() {
      this.transfer = { group: '', subgroup: '', assignedTo: '' }
      // this.$set(
      //   this.transfer,
      //   'group',
      //   this.agentGroup.find((el) => el.groupname == 'Agent')
      // )
      this.showDialogSelectAgent = true
    },
    onAssignInput(val) {
      if (val) {
        this.transfer.group = this.agentGroup.find((el) => el.id == val.admingroupid)
        this.transfer.subgroup = this.agentSubGroup.find((el) => el.id == val.adminsubgroupid)
      }
    },
    async onChangeSubGroup() {
      this.transfer.assignedTo = null
    },
    async onChangeGroup() {
      this.transfer.subgroup = null
      this.transfer.assignedTo = null
    },
    async updateTicket(fieldName, value) {
      this.$set(this.ticket, fieldName, value)
      const data = {
        ...this.formatTicketData(this.ticket),
        page_id: this.selectedBot.pageid // required
      }
      this.editloading = true
      try {
        await this.editTicket(data)
      } catch (error) {
        handleApiError(error)
      }
      this.onEditTicket(this.ticket)

      this.editloading = false
    },
    editTicket(data) {
      return ticket3TicketManagementApi.putTicketManagement({ data })
    },
    onEditTicket(ticket) {
      var vm = this
      const newTicket = {
        ...ticket,
        assignadminid: ticket.assign_admin_id,
        assigngroupid: ticket.assign_group_id,
        assignsubgroupid: ticket.assign_sub_group_id
      }
      this.$emit('update:ticket', { ...vm.ticket, ...newTicket })
      vm.editDialogOpen = false
    },
    async handleShowHistory(id) {
      const vm = this
      vm.loadingHistory = true
      vm.showHistory = true
      await vm.handleGetTicketHistory(id)
    },
    handleCloseHistory() {
      this.historyData = null
      this.showHistory = false
    },
    async handleGetTicketHistory(id) {
      const vm = this
      try {
        const response = await ticket3TicketManagementApi.getTicketManagementHistory({
          params: { page_id: vm.selectedBot.pageid, ticket_id: id }
        })

        if (response.status == 200) {
          vm.historyData = response.data.history
          vm.loadingHistory = false
        }
      } catch (error) {
        vm.loadingHistory = false
        handleApiError(error)
      }
    },
    dayLeft: function (replytime) {
      var lastreply = moment(replytime)
      var currentDate = moment()

      var time = ''
      if (currentDate.diff(lastreply, 'days') > 0) {
        time = lastreply.format('DD MMM YYYY')
      } else if (currentDate.diff(lastreply, 'hours') > 0) {
        time = currentDate.diff(lastreply, 'hours')
        time += ' ' + 'Hours'
      } else if (currentDate.diff(lastreply, 'minutes') > 0) {
        time = currentDate.diff(lastreply, 'minutes')
        time += ' ' + 'Minutes'
      } else if (currentDate.diff(lastreply, 'seconds') > 0) {
        time = currentDate.diff(lastreply, 'seconds')
        time += ' ' + 'Seconds'
      }
      return time
    },
    priorityColor(item) {
      if (item) {
        if (item.toLowerCase() == 'low') {
          return 'green'
        } else if (item.toLowerCase() == 'medium') {
          return 'orange'
        } else if (item.toLowerCase() == 'high') {
          return 'red'
        }
      } else {
        return 'grey'
      }
    },
    durationTime(start, end) {
      if (!start || !end) return

      var startTime = start
      var endTime = end
      var seconds = moment
        .duration(
          moment(endTime, 'YYYY/MM/DD HH:mm:ss').diff(moment(startTime, 'YYYY/MM/DD HH:mm:ss'))
        )
        .asSeconds()
      var displayHours = Math.floor(seconds / 3600)
      var displayMinutes = Math.floor(seconds / 60) % 60
      var displaySeconds = seconds % 60
      return `${displayHours}h ${displayMinutes}m ${displaySeconds}s`
    },
    addDurationUnit(minutes) {
      return moment.duration(parseFloat(minutes), 'minutes').format('h [hrs], m [min]')
    }
  }
}
</script>

<style>
.chipcustomfacebook {
  background-color: rgb(59, 89, 152) !important;
  border-color: rgb(59, 89, 152) !important;
  border-radius: 5px !important;
  height: 24px !important;
}

.chipcustomline {
  background-color: #00c300 !important;
  border-color: #00c300 !important;
  border-radius: 5px !important;
  height: 24px !important;
}

.groupticket2 {
  cursor: pointer;
  color: darkgrey;
}

.groupticket2:hover {
  color: rgb(94, 94, 94);
}
</style>

<style lang="scss" scoped>
.social-chip {
  max-width: 100%;

  > .v-chip__content {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/TicketItem.vue